import React from 'react';

import styled, { css, useTheme } from 'styled-components';

import { Translate } from 'react-localize-redux';

import Hint from '@components/basics/hint';
import Flex from '@components/layout/flex';
import InputField from '@components/form/input';
import Typography from '@components/basics/typography';
import UnselectedIcon from '@components/basics/icons/unselected';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';

interface MerchProductQuantityProps {
  quantity: string;
  setQuantity: React.Dispatch<React.SetStateAction<string>>;
  isUnlimited: boolean;
  setIsUnlimited: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MerchProductQuantity = ({
  quantity,
  setQuantity,
  isUnlimited,
  setIsUnlimited,
}: MerchProductQuantityProps) => {
  const theme = useTheme();

  const rightDecoration = (
    <StyledDecorationContainer
      justifyContent="flex-end"
      alignItems="center"
      gap={10}
      onClick={() => setIsUnlimited((prev) => !prev)}
    >
      <Typography
        type="small"
        uppercase
        weight="700"
        color={isUnlimited ? theme.colors.differentBackground : undefined}
      >
        <Translate id="MERCH.SECTIONS.PRICING.QUANTITY.PRODUCT.UNLIMITED_LABEL" />
      </Typography>
      {isUnlimited ? (
        <CompletedIcon className="check-icon" size={24} />
      ) : (
        <UnselectedIcon className="check-icon" iconSize={24} />
      )}
    </StyledDecorationContainer>
  );

  return (
    <div>
      <Typography className="mb-20" customFont="medium" type="big-title">
        <Translate id="MERCH.SECTIONS.PRICING.QUANTITY.PRODUCT.TITLE" />
      </Typography>
      <StyledInputField
        isChecked={isUnlimited}
        customBorderRadius="4px 4px 0px 0px"
        label={`Quantity`}
        rightDecoration={rightDecoration}
        autoComplete="off"
        value={quantity}
        onChange={(value) => setQuantity(value)}
        locked={isUnlimited}
      />
      <Hint
        noBorderTop
        customTitle={
          <Translate id="MERCH.SECTIONS.PRICING.QUANTITY.PRODUCT.HINT.TITLE" />
        }
      >
        <Translate id="MERCH.SECTIONS.PRICING.QUANTITY.PRODUCT.HINT.SUBTITLE" />
      </Hint>
    </div>
  );
};

const StyledDecorationContainer = styled(Flex)`
  cursor: pointer;
`;

const StyledInputField = styled(InputField)<{ isChecked?: boolean }>`
  ${({ isChecked }) =>
    isChecked
      ? css`
          background-color: ${({ theme }) => theme.colors.primary};

          input {
            color: ${({ theme }) => theme.colors.background};
            background-color: ${({ theme }) => theme.colors.primary};
          }

          label {
            color: ${({ theme }) => theme.colors.background};
          }

          .decoration-left {
            &:before {
              background-color: ${({ theme }) => theme.colors.white};
            }
          }
        `
      : null}
`;
